// extracted by mini-css-extract-plugin
module.exports = {"chart":"Nodes_chart__1rEV2","chart_title":"Nodes_chart_title__2Ux0-"};